import type { InjectionKey, MaybeRef } from 'vue'
import type { User } from '#shared/model/user'
import type { guest } from './guest'

export const userInjectionKey = Symbol('User') as InjectionKey<MaybeRef<User | typeof guest | undefined>>
